import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import BackMethods from "../../back_component/BackMethods";
import {
    FaFileInvoice,
    FaEye,
    FaCalendarDay,
    FaExclamationCircle,
    FaBox
} from "react-icons/fa";
import "./ViolationPage.css";

export default function ViolationPage() {

    const navigate = useNavigate();
    const { backEnd_request } = BackMethods();

    const [searchParams, setSearchParams] = useSearchParams();

    const violationTypeId = searchParams.get("violationTypeId");
    const establishment = searchParams.get("establishment");
    const reportNumber = searchParams.get("reportNumber");
    const inspector = searchParams.get("inspector");

    const page = parseInt(searchParams.get("page")) || 1;
    const size = parseInt(searchParams.get("size")) || 20;

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const [reports, setReports] = useState([]);
    const [totalPages, setTotalPages] = useState(1);
    const [totalRecords, setTotalRecords] = useState(0);

    const truncateWords = (text, limit) => {
        if (!text) return "---";
        const words = text.split(" ");
        if (words.length > limit) {
            return words.slice(0, limit).join(" ") + "...";
        }
        return text;
    };

    const handlePageChange = (p) => {

        if (p < 1 || p > totalPages) return;

        const params = {
            violationTypeId,
            establishment,
            reportNumber,
            inspector,
            page: p,
            size
        };

        Object.keys(params).forEach(k => !params[k] && delete params[k]);

        setSearchParams(params);

        window.scrollTo({ top: 0, behavior: "smooth" });

    };

    const formatDate = (value) => {
        if (!value) return "---";
        try {
            return new Date(value).toLocaleDateString("ar-SY");
        } catch {
            return value;
        }
    };

    const searchDescriptor = establishment
        ? `نتائج حسب المنشأة: ${establishment}`
        : violationTypeId
            ? "نتائج حسب نوع المخالفة"
            : reportNumber
                ? `نتائج حسب رقم الضبط: ${reportNumber}`
                : inspector
                    ? `نتائج حسب اسم المنظم: ${inspector}`
                    : "عرض عام للضبوط";

    useEffect(() => {

        const load = async () => {

            setLoading(true);
            setError("");

            try {

                let data = [];

                if (establishment) {

                    data = await backEnd_request
                        .get(`/ViolationReports/by-establishment/${establishment}`)
                        .then(r => r.data);

                    setReports(data);
                    setTotalRecords(Array.isArray(data) ? data.length : 0);
                    setTotalPages(1);

                }

                else if (violationTypeId) {

                    data = await backEnd_request.get(
                        `/ViolationReports/by-type`,
                        {
                            params: {
                                violationTypeId,
                                page,
                                size
                            }
                        }
                    ).then(r => r.data);
                    setReports(data.data || []);
                    setTotalRecords(data.total || 0);
                    setTotalPages(Math.ceil((data.total || 0) / size));

                }

                else if (reportNumber) {

                    data = await backEnd_request
                        .get(`/ViolationReports/by-report-number?number=${reportNumber}`)
                        .then(r => r.data);

                    setReports(data);
                    setTotalRecords(Array.isArray(data) ? data.length : 0);
                    setTotalPages(1);

                }

                else if (inspector) {

                    data = await backEnd_request
                        .get(`/ViolationReports/by-inspector?inspectorName=${inspector}`)
                        .then(r => r.data);

                    setReports(data);
                    setTotalRecords(Array.isArray(data) ? data.length : 0);
                    setTotalPages(1);

                }

            } catch (err) {

                console.error(err);
                setError("تعذر تحميل الضبوط حالياً. حاول مرة أخرى بعد قليل.");
                setReports([]);
                setTotalRecords(0);
                setTotalPages(1);

            } finally {

                setLoading(false);

            }

        };

        load();

    }, [searchParams]);

    return (

        <div className="bg-light min-vh-100 py-4" dir="rtl">

            <div className="container-fluid px-3 px-lg-4 violation-page">

                <div className="violation-page__hero">
                    <div className="violation-page__hero-main">
                        <div className="violation-page__hero-icon">
                            <FaFileInvoice />
                        </div>
                        <div>
                            <h4 className="fw-bold m-0 violation-page__title">
                                سجل الضبوط المنظمة
                            </h4>
                            <p className="violation-page__subtitle mb-0">
                                {searchDescriptor}
                            </p>
                        </div>
                    </div>

                    <div className="violation-page__hero-actions">
                        <div className="violation-page__stats">
                            <span className="violation-page__chip">
                                إجمالي السجلات: {totalRecords}
                            </span>
                            {/* <span className="violation-page__chip violation-page__chip--soft">
                                الصفحة: {page} / {totalPages}
                            </span> */}
                        </div>
                        <button
                            onClick={() => navigate(-1)}
                            className="btn btn-dark btn-sm rounded-pill px-4 shadow-sm violation-page__back-btn"
                        >
                            رجوع
                        </button>
                    </div>
                </div>

                {loading ? (

                    <div className="text-center py-5 bg-white rounded-4 shadow-sm border violation-page__state-card">
                        <div className="spinner-border text-primary"></div>
                        <div className="mt-3 fw-bold text-primary">جاري تحميل الضبوط...</div>
                    </div>

                ) : error ? (

                    <div className="text-center py-5 bg-white rounded-4 shadow-sm border violation-page__state-card">
                        <div className="violation-page__empty-icon text-danger">
                            <FaExclamationCircle />
                        </div>
                        <h5 className="mt-3 mb-2 text-danger">حدث خطأ أثناء التحميل</h5>
                        <p className="text-muted mb-3">{error}</p>
                        <button
                            className="btn btn-outline-danger rounded-pill px-4"
                            onClick={() => window.location.reload()}
                        >
                            إعادة المحاولة
                        </button>
                    </div>

                ) : (

                    <div className="violation-page__content-card">
                        <div className="violation-page__content-head">
                            <div>
                                <h5 className="mb-1 fw-bold text-dark">قائمة الضبوط</h5>
                                <div className="text-muted small">
                                    راجع نوع المخالفة، المنشأة، الموقع، ووقت التنظيم بسرعة أكبر.
                                </div>
                            </div>
                            <div className="violation-page__content-meta">
                                <span className="violation-page__meta-box">
                                    عدد العناصر في الصفحة: {reports.length}
                                </span>
                            </div>
                        </div>

                        <div className="table-responsive custom-table-container">

                            <table className="table table-hover align-middle main-modern-table px-4 violation-page__table">

                                <thead>
                                    <tr>
                                        <th>رقم الضبط</th>
                                        <th>نوع المخالفة</th>
                                        <th>المنشأة</th>
                                        {/* <th>المحجوزات</th> */}
                                        <th>الموقع</th>
                                        <th>التاريخ والوقت</th>
                                        <th className="text-center">عرض</th>
                                    </tr>
                                </thead>

                                <tbody>

                                    {reports.map((r) => (

                                        <tr key={r.violationReportId} className="table-row-item">

                                            <td>
                                                <div className="fw-bold text-primary fs-6 violation-page__report-number">
                                                    #{r.reportNumber}
                                                </div>
                                                <div className="x-small text-muted">
                                                    {r.caseNumber ? `قضية: ${r.caseNumber}` : "بدون رقم قضية"}
                                                </div>
                                            </td>

                                            <td className="violation-page__violation-col">
                                                <div className="d-flex align-items-start gap-2">

                                                    <FaExclamationCircle className="text-warning mt-2" />

                                                    <div>

                                                        <div className="fw-bold ">
                                                            {r.violationType?.name || "غير محدد"}
                                                        </div>

                                                        <div className=" small ">
                                                            {truncateWords(r.violationSummary, 25)}
                                                        </div>

                                                    </div>

                                                </div>
                                            </td>

                                            <td>
                                                <div className="fw-bold small violation-page__est-link"
                                                    onClick={() =>
                                                        navigate(`/admin/establishments/${r.establishment.fieldUid}`)
                                                    }
                                                >
                                                    {r.establishment?.name || "غير محدد"}
                                                </div>
                                                <span className="badge bg-soft-dark text-dark border fw-normal x-small violation-page__offender-badge">
                                                    {r.offenderName}
                                                </span>
                                            </td>

                                            {/* <td>
                                            <div className="small">
                                                <FaBox className="ms-1 text-secondary" />
                                                {r.seizedQuantity || 0}
                                            </div>

                                            <div className="x-small text-muted">
                                                {r.depositDestination || "---"}
                                            </div>
                                        </td> */}

                                            <td>
                                                <div className="small fw-bold">
                                                    {r.governorate}
                                                </div>

                                                <div className="small text-muted">
                                                    {r.city} - {r.district}
                                                </div>
                                            </td>

                                            <td>
                                                <div className="small fw-bold text-dark">
                                                    <FaCalendarDay className="ms-1 text-info" />
                                                    {formatDate(r.reportDate)}
                                                </div>

                                                <div className="x-small text-muted">
                                                    {r.reportTime?.slice(0, 5)} | {r.dayName}
                                                </div>
                                            </td>

                                            <td className="text-center">

                                                <button
                                                    className="action-btn view mx-auto"
                                                    title="عرض التفاصيل"
                                                    onClick={() =>
                                                        navigate(`/admin/violation-details?id=${r.reportNumber}`)
                                                    }
                                                >
                                                    <FaEye />
                                                </button>

                                            </td>

                                        </tr>

                                    ))}

                                </tbody>

                            </table>

                            {reports.length === 0 && (

                                <div className="text-center py-5 bg-white rounded-4 shadow-sm mt-3 text-muted violation-page__state-card">
                                    <div className="violation-page__empty-icon">
                                        <FaBox />
                                    </div>
                                    <h5 className="mt-3 mb-2 text-dark">لا توجد سجلات حالياً</h5>
                                    <div>جرّب تغيير معايير البحث أو العودة إلى الصفحة السابقة.</div>
                                </div>

                            )}

                            {totalPages > 1 && (

                                <div className="d-flex justify-content-center mt-4">

                                    <nav>

                                        <ul className="pagination pagination-sm mb-0 gap-1 flex-wrap justify-content-center">

                                            <li className={`page-item ${page === 1 ? "disabled" : ""}`}>

                                                <button
                                                    className="page-link rounded-circle border-0 shadow-sm p-2"
                                                    onClick={() => handlePageChange(page - 1)}
                                                >
                                                    ‹
                                                </button>

                                            </li>

                                            {Array.from({ length: totalPages }, (_, i) => i + 1)
                                                .filter(p =>
                                                    p === 1 ||
                                                    p === totalPages ||
                                                    Math.abs(p - page) <= 1
                                                )
                                                .map((p, idx, arr) => (

                                                    <React.Fragment key={p}>

                                                        {idx > 0 && arr[idx - 1] !== p - 1 && (
                                                            <span className="mx-1 text-muted">...</span>
                                                        )}

                                                        <li className={`page-item ${page === p ? "active" : ""}`}>

                                                            <button
                                                                className="page-link rounded-circle border-0 shadow-sm fw-bold mx-1 violation-page__page-btn"
                                                                onClick={() => handlePageChange(p)}
                                                            >
                                                                {p}
                                                            </button>

                                                        </li>

                                                    </React.Fragment>

                                                ))}

                                            <li className={`page-item ${page === totalPages ? "disabled" : ""}`}>

                                                <button
                                                    className="page-link rounded-circle border-0 shadow-sm p-2"
                                                    onClick={() => handlePageChange(page + 1)}
                                                >
                                                    ›
                                                </button>

                                            </li>

                                        </ul>

                                    </nav>

                                </div>

                            )}

                        </div>
                    </div>

                )}

            </div>

        </div>

    );

}